import type { Assertion } from '../api/evalApi';

export const assertionTypeOptions: Array<{
  type: Assertion['type'];
  label: string;
  description: string;
}> = [
  {
    type: 'contains',
    label: 'Contains',
    description: 'Output must include the provided text.',
  },
  {
    type: 'not_contains',
    label: 'Not Contains',
    description: 'Output must not include the provided text.',
  },
  {
    type: 'is_json',
    label: 'Is JSON',
    description: 'Output must be valid JSON.',
  },
  {
    type: 'json_path',
    label: 'JSON Path',
    description: 'Evaluate fields from JSON output by path.',
  },
  {
    type: 'regex',
    label: 'Regex',
    description: 'Output must match the regular expression.',
  },
  {
    type: 'min_length',
    label: 'Min Length',
    description: 'Output length must be at least this value.',
  },
  {
    type: 'max_length',
    label: 'Max Length',
    description: 'Output length must be at most this value.',
  },
  {
    type: 'judge',
    label: 'Judge',
    description: 'LLM rubric scoring with optional threshold.',
  },
  {
    type: 'tool_call_sequence',
    label: 'Tool Call Sequence',
    description: 'Agent must invoke tools in the specified order (subsequence match).',
  },
];

export const jsonPathOperatorOptions: Array<{
  value: 'exists' | 'equals' | 'contains';
  label: string;
}> = [
  { value: 'exists', label: 'Exists' },
  { value: 'equals', label: 'Equals' },
  { value: 'contains', label: 'Contains' },
];

export function getAssertionDescription(type: Assertion['type']): string {
  return assertionTypeOptions.find((option) => option.type === type)?.description ?? '';
}

export function defaultAssertionForType(type: Assertion['type']): Assertion {
  switch (type) {
    case 'contains':
    case 'not_contains':
    case 'regex':
      return { type, value: '' };
    case 'is_json':
      return { type };
    case 'json_path':
      return { type, path: '', operator: 'exists' };
    case 'min_length':
    case 'max_length':
      return { type, value: 0 };
    case 'judge':
      return { type, rubric: '', threshold: 0.7 };
    case 'tool_call_sequence':
      return { type, value: [] };
    default:
      return { type: 'contains', value: '' };
  }
}
